import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CatalogTile } from "../config/tileCatalog";
import {
	CatalogAvailabilityContext,
	getCatalogTileDisabledState,
} from "../utils/catalogAvailability";
import { CatalogCard } from "./CatalogCard";

interface CatalogGridProps {
	tiles: CatalogTile[];
	highlightedTileId?: string | null;
	availabilityContext: CatalogAvailabilityContext;
	isFavorite?: (id: string) => boolean;
	/** A list create is in flight: every tile is disabled so no second click starts another. */
	isBusy?: boolean;
	onToggleFavorite?: (tile: CatalogTile) => void;
	onSelectTile: (tile: CatalogTile) => void;
}

export const CatalogGrid: FunctionComponent<CatalogGridProps> = ({
	tiles,
	highlightedTileId,
	availabilityContext,
	isFavorite,
	isBusy = false,
	onToggleFavorite,
	onSelectTile,
}) => {
	const { t } = useTranslation();

	if (tiles.length === 0) {
		return (
			<div className="rounded-xl border border-dashed border-gray-300 bg-white p-8 text-center text-sm text-text-meta">
				{t("list.create.catalog.empty")}
			</div>
		);
	}

	return (
		<div className="grid grid-cols-1 gap-3 tb:grid-cols-2 lg:grid-cols-3">
			{tiles.map((tile) => (
				<CatalogCard
					key={tile.id}
					disabledState={getCatalogTileDisabledState(tile, availabilityContext)}
					isBusy={isBusy}
					isCompact
					isFavorite={isFavorite?.(tile.id)}
					isHighlighted={highlightedTileId === tile.id}
					tile={tile}
					onClick={onSelectTile}
					onToggleFavorite={onToggleFavorite}
				/>
			))}
		</div>
	);
};
